// Team accent palette — tuned for legibility on the deep-navy Totem background.
// Some teams' primaries (Spurs navy, Newcastle black, Villa claret) barely show
// against a #0B0D10 canvas, so we substitute their kit secondary or a
// brightened variant. Keyed by FPL `short_name` (stable across seasons).

export const DEFAULT_COLOR = { primary: "#E3C32B", rgb: "227,195,43", name: "Totem Gold" };

export const NEUTRAL_COLOR = { primary: "#00FF85", rgb: "0,255,133", name: "Neutral Green" };

export const TEAM_COLORS = {
  ARS: { primary: "#EF0107", rgb: "239,1,7", name: "Arsenal Red" },
  AVL: { primary: "#AF3053", rgb: "175,48,83", name: "Villa Claret" },
  BOU: { primary: "#DA291C", rgb: "218,41,28", name: "Cherries Red" },
  BRE: { primary: "#E30613", rgb: "227,6,19", name: "Brentford Red" },
  BHA: { primary: "#4A9BE3", rgb: "74,155,227", name: "Seagull Blue" },
  BUR: { primary: "#B4547A", rgb: "180,84,122", name: "Burnley Claret" },
  CHE: { primary: "#4D7DD1", rgb: "77,125,209", name: "Chelsea Blue" },
  CRY: { primary: "#4A78C3", rgb: "74,120,195", name: "Palace Blue" },
  EVE: { primary: "#4D7BE3", rgb: "77,123,227", name: "Toffees Blue" },
  FUL: { primary: "#E5E5E5", rgb: "229,229,229", name: "Cottagers White" },
  IPS: { primary: "#4A7BC3", rgb: "74,123,195", name: "Tractor Blue" },
  LEE: { primary: "#FFCD00", rgb: "255,205,0", name: "Leeds Gold" },
  LEI: { primary: "#4A78C3", rgb: "74,120,195", name: "Foxes Blue" },
  LIV: { primary: "#E63946", rgb: "230,57,70", name: "Anfield Red" },
  MCI: { primary: "#6CABDD", rgb: "108,171,221", name: "Sky Blue" },
  MUN: { primary: "#DA291C", rgb: "218,41,28", name: "United Red" },
  NEW: { primary: "#F1BE48", rgb: "241,190,72", name: "Magpies Yellow" },
  NFO: { primary: "#DD0000", rgb: "221,0,0", name: "Forest Red" },
  SHU: { primary: "#EE2737", rgb: "238,39,55", name: "Blades Red" },
  SOU: { primary: "#E63946", rgb: "230,57,70", name: "Saints Red" },
  SUN: { primary: "#C71C1D", rgb: "199,28,29", name: "Mackems Red" },
  TOT: { primary: "#B0C4E5", rgb: "176,196,229", name: "Lilywhites Silver" },
  WHU: { primary: "#B85A6E", rgb: "184,90,110", name: "Hammers Claret" },
  WOL: { primary: "#FDB913", rgb: "253,185,19", name: "Wolves Gold" },
};

/**
 * Resolve a team accent from a favorite_team_id + list of teams from bootstrap.
 *  - favorite_team_id === 0  → Neutral Fan (uses the app's green)
 *  - null / undefined        → default Totem Gold
 *  - team id                 → look up its short_name, then TEAM_COLORS
 */
export function resolveAccent(favoriteTeamId, teams) {
  if (favoriteTeamId === 0) return { ...NEUTRAL_COLOR, teamShort: "NEU" };
  if (favoriteTeamId === null || favoriteTeamId === undefined) return { ...DEFAULT_COLOR, teamShort: null };
  const team = (teams || []).find((t) => t.id === favoriteTeamId);
  if (!team) return { ...DEFAULT_COLOR, teamShort: null };
  const c = TEAM_COLORS[team.short_name] || DEFAULT_COLOR;
  return { ...c, teamShort: team.short_name, teamName: team.name };
}
